export const RoleConstant = {
  ADMIN: "Admin",
  SALES_COORDINATOR: "Sales Coordinator",
  SALES_COORDINATOR_DISPLAY: "RSM_ASM",
  USER: "User",
  MANAGER: "Manager",
  ENQUIRY_USER: "EnquiryUser",
  FIELD_STAFF: "FieldStaff",
};
